import { Button, Flex, Modal, ScrollArea } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { observer } from 'mobx-react';
import { t } from 'i18next';
import remarkGfm from 'remark-gfm';

interface SupportModalModalProps {
    opened: boolean;
    onClose: () => void;
}

export const SupportModal: React.FC<SupportModalModalProps> = observer(({ opened, onClose }) => {
    const { i18n } = useTranslation();
    const [markdown, setMarkdown] = useState('');

    useEffect(() => {
        if (!opened) return;

        const loadMarkdown = async () => {
            try {
                const res = await fetch(`/support/${i18n.language}.md`);
                const text = await res.text();
                setMarkdown(text);
            } catch {
                setMarkdown('⚠️ Failed to load terms.');
            }
        };

        loadMarkdown();
    }, [i18n.language, opened]);

    return (
        <Modal opened={opened} onClose={onClose} title={t('navbar.support')} size="lg" centered>
            <ScrollArea h={'50%'}>
                <ReactMarkdown remarkPlugins={[remarkGfm]} skipHtml={false}>
                    {markdown}
                </ReactMarkdown>
            </ScrollArea>

            <Flex justify={'flex-end'}>
                <Button onClick={onClose}>{t('button.close')}</Button>
            </Flex>
        </Modal>
    );
});

export default SupportModal;

export const capitalizeFirst = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
